import { Box, Typography } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import React from "react";
import { useMemo } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { toast } from "react-toastify";
import {
  getDrugsInArea,
  putAddDrugInArea,
  putAddEquipmentInArea,
} from "../../../api/area";
import { getGroupsDrugInArea } from "../../../api/group";
import {
  addAllEquipmentsToArea,
  getEquipmentCount,
} from "../../../api/jahadgar";
import FlagIcon from "../../../assets/SVG/flagIcon";
import CountDrugPop from "../countDrugPop";

export default function GroupTableOnline({
  rowData,
  setDataDrugSelect,
  dataDrugSelect,
  equipment,
  notGroup,
}) {
  // const [inputValues, setInputValues] = useState({}); // برای نگه داشتن مقادیر اینپوت‌ها

  //   const handleInputChange = (e, id) => {
  //    const { value } = e.target;

  //   // به‌روزرسانی مقدار اینپوت بر اساس شناسه سطر
  //   setInputValues((prev) => ({
  //     ...prev,
  //     [id]: value, // مقدار جدید برای ردیف خاص
  //   }));

  //   // به‌روزرسانی rowData با مقدار جدید
  //   const updatedData = rowData.map((item) =>
  //     item.id === id ? { ...item, dose: value } : item // فقط ردیفی که مقدارش تغییر کرده آپدیت می‌شود
  //   );
  //   };
  // console.log(inputValues);
  //   console.log(dataDrugSelect);
  const [open, setOpen] = useState();
  const [dataCountDrug, setDataCountDrug] = useState();
  const [areaId, setAreaId] = useState();

  const [colDefs] = useState([
    {
      field: "area",
      headerName: "نام گروه",
      width: 140,
      cellRenderer: (x) => {
        return (
          <Box
            // onClick={() => console.log(x.data.groupsWithAccess[0].group.name)}
            display="flex"
            alignItems="center"
          >
            {x.data.groupsWithAccess?.length > 0 &&
              x.data.groupsWithAccess[0].group.name}
          </Box>
        );
      },
    },
    {
      field: "name",
      headerName: "منطقه",
      width: 100,
      cellRenderer: (x) => {
        return (
          <Box display="flex" alignItems="center">
            <Typography fontFamily="Shabnam">{x.data?.name}</Typography>
          </Box>
        );
      },
    },
    {
      field: "dose",
      headerName: "مسئول منطقه",
      width: 140,
      cellRenderer: (x) => {
        return (
          <Box display="flex" alignItems="center">
            <Typography fontFamily="Shabnam">
              {x.data?.areas?.length > 0 && x.data?.areas[0]?.owner?.name}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "dose",
      headerName: "تعداد",
      width: 110,
      cellRenderer: (x) => {
        return (
          <Box display="flex" alignItems="center">
            <input
              style={{
                width: "50px",
                height: "30px",
                border: "none",
                boxShadow: "0px 1px 2px 0px #00000014",
                borderRadius: "9px",
              }}
              // value={inputValues[x.data.id] || ""} // مقدار اینپوت برای هر سطر
              onChange={(e) => x.setValue(e.target.value)}
            />
          </Box>
        );
      },
    },
    {
      field: "dose",
      headerName: "عملیات",
      width: 250,
      cellRenderer: (x) => {
        return (
          <Box display="flex" gap="10px" alignItems="center">
            <button
              style={{
                display: "flex",
                border: "none",
                background: "#00A3FF",
                borderRadius: "9px",
                padding: "5px",
                // fontFamily: "Shabnam !important ",
              }}
              onClick={() => {
                const updatedArray = dataDrugSelect.map((item) => {
                  return {
                    ...item, // نگه داشتن اطلاعات قبلی
                    totalCount: Number(x.value), // اضافه کردن فیلد جدید
                  };
                });
                if (equipment) {
                  if (notGroup) {
                    addAllEquipmentsToArea(x.data?.id, updatedArray)
                      .then((z) => toast.success("تجهیزات انتقال پیدا کرد"))
                      .catch(() => {});
                  } else {
                    putAddEquipmentInArea(x.data?.areas[0]?.id, updatedArray)
                      .then((z) => toast.success("تجهیزات انتقال پیدا کرد"))
                      .catch(() => {});
                  }
                } else {
                  if (notGroup) {
                    putAddDrugInArea(x.data?.id, updatedArray)
                      .then((z) => toast.success("دارو انتقال پیدا کرد"))
                      .catch(() => {});
                  } else {
                    putAddDrugInArea(x.data?.areas[0]?.id, updatedArray)
                      .then((z) => toast.success("دارو انتقال پیدا کرد"))
                      .catch(() => {});
                  }
                }
              }}
            >
              <FlagIcon color="white" />
              <Typography color="white" fontSize="14px" fontFamily="Shabnam">
                افزودن به اردو
              </Typography>
            </button>
            <button
              style={{
                display: "flex",
                border: "none",
                background: "#00A3FF",
                borderRadius: "9px",
                padding: "5px",
                // fontFamily: "Shabnam !important ",
              }}
              onClick={() => {
                if (equipment) {
                  if (notGroup) {
                    getEquipmentCount(x.data?.id)
                      .then((z) => {
                        setDataCountDrug(z);
                        setAreaId(x.data?.id);
                        setOpen(true);
                      })
                      .catch(() => {});
                  } else {
                    getEquipmentCount(x.data?.areas[0]?.id)
                      .then((z) => {
                        setDataCountDrug(z);
                        setAreaId(x.data?.areas[0]?.id);
                        setOpen(true);
                      })
                      .catch(() => {});
                  }
                } else {
                  if (notGroup) {
                    getDrugsInArea(x.data?.id)
                      .then((z) => {
                        setDataCountDrug(z);
                        setAreaId(x.data?.id);
                        setOpen(true);
                      })
                      .catch(() => {});
                  } else {
                    getDrugsInArea(x.data?.areas[0]?.id)
                      .then((z) => {
                        setDataCountDrug(z);
                        setAreaId(x.data?.areas[0]?.id);
                        setOpen(true);
                      })
                      .catch(() => {});
                  }
                }

                // console.log(x.data?.id);
              }}
            >
              <Typography color="white" fontSize="14px" fontFamily="Shabnam">
                مشاهده تعداد
              </Typography>
            </button>
          </Box>
        );
      },
    },
  ]);

  const defaultColDef = useMemo(() => ({
    filter: true,
    editable: true,
  }));
  return (
    // <Box calssName="table_drug_griups">
    <>
      <CountDrugPop
        equipment={equipment}
        areaId={areaId}
        data={dataCountDrug}
        open={open}
        setOpen={setOpen}
      />
      <div
        className="ag-theme-quartz"
        style={{ height: "260px", minHeight: "15vw", marginTop: 10 }}
      >
        <AgGridReact
          // pagination={true}
          rowHeight={60}
          enableRtl={true}
          rowData={rowData}
          rowStyle={{ backgroundColor: "#F5F9FF" }}
          // ref={gridRef}
          columnDefs={colDefs}
          defaultColDef={defaultColDef}
          className="table_drug_griups"
        />
      </div>
    </>
    // </Box>
  );
}
